import { createContext, useMemo, useReducer, useRef } from 'react';

export default (initialState, processActions, reducer) => {
  const Context = createContext(initialState);
  let actions;

  const Provider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const actionsRuntime = useRef({});
    actions = processActions(state, dispatch, actionsRuntime.current);
    return <Context.Provider value={state}>{children}</Context.Provider>;
  };

  return {
    Context,
    Provider,
    actions: () => {
      return actions;
    },
  };
};
